// Task archive/delete button visibility — mirrors the backend
// authorization in backend/routes/tasks.py exactly (archive_task,
// delete_task), so a control is never shown for an action the backend
// would reject. The backend remains the final enforcement layer; this
// only decides what to render.
//
// `canUpdateProject` must be the same signal the backend checks —
// `user_can_access_project(user, project_id, "can_update")` — which the
// project payload already exposes as `project.user_permissions.can_update`.
export function getTaskActionPermissions(task, user, canUpdateProject) {
  if (!task || !user || user.user_type !== "internal") {
    return { canArchive: false, canDelete: false };
  }
  const isCreator = task.created_by === user.id;
  const isPlatformAdmin = user.role === "platform_admin";
  return {
    // Backend: creator OR platform_admin OR project can_update.
    canArchive: isCreator || isPlatformAdmin || !!canUpdateProject,
    // Backend: creator OR platform_admin only — can_update alone is not
    // enough for permanent deletion.
    canDelete: isCreator || isPlatformAdmin,
  };
}
